import { useTranslation } from 'react-i18next'
import { Form, Input, Button, Space, Select } from 'antd'
import type { Twilio2FaSend } from '../../../../api/schema'
import { SmsMarketingConsent } from '../../../shared/SmsMarketingConsent/SmsMarketingConsent'

type SendCodeFormValues = {
  to: string
  sms_notifications: boolean
}

type SendCodeFormProps = {
  onFinish: (values: Twilio2FaSend) => void
  loading: boolean
  showConsent?: boolean
}

export const SendCodeForm = ({ onFinish, loading, showConsent = true }: SendCodeFormProps) => {
  const { t } = useTranslation()

  return (
    <Form<SendCodeFormValues>
      name='sendcode'
      layout='vertical'
      onFinish={(values) => {
        onFinish({
          to: `+1${values.to}`,
          sms_notifications: values.sms_notifications,
        })
      }}
      initialValues={{ sms_notifications: false }}
    >
      <Form.Item
        name='to'
        label={t('mobile_phone_number_label')}
        className='font-medium'
      >
        <Space.Compact style={{ width: '100%' }}>
          <Select
            value='+1'
            disabled
            style={{ width: 48 }}
            options={[{ label: '+1', value: '+1' }]}
            suffix=''
          />
          <Input
            data-testid='input-tel'
            size='large'
            type='tel'
            inputMode='numeric'
            required
          />
        </Space.Compact>
      </Form.Item>
      {showConsent ? (
        <div className='my-6'>
          <SmsMarketingConsent />
        </div>
      ) : (
        <div className='my-6' />
      )}
      <Button
        type='primary'
        htmlType='submit'
        size='large'
        block
        loading={loading}
        data-testid='send-code-submit-button'
      >
        {t('send_code_cta')}
      </Button>
    </Form>
  )
}
